// A list of tap-to-open questions, in the app's own theme colours. Used by
// Settings → FAQs. Only one answer is open at a time (Jade): the parent holds
// the open row as `openKey` ("<group>:<question>") so that opening a question
// in one group also closes the other group's. (The purchase page has its own
// styled copy.)
import { ChevronDown } from 'lucide-react';

export default function FaqList({ items, group = '', openKey, onToggle }) {
  return (
    <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
      {items.map((f, i) => {
        const key = `${group}:${f.q}`;
        const isOpen = openKey === key;
        return (
          <li key={f.q} style={{ borderTop: i ? '1px solid var(--c-border-light, #f5eaf0)' : 'none' }}>
            <button
              type="button"
              aria-expanded={isOpen}
              onClick={() => onToggle(isOpen ? null : key)}
              style={{
                width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '11px 0',
                background: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left',
                fontFamily: 'inherit', fontSize: 13, fontWeight: 600, color: 'var(--c-text)', lineHeight: 1.35,
              }}
            >
              <span style={{ flex: 1 }}>{f.q}</span>
              <ChevronDown size={16} color="var(--c-text-soft)" style={{ flexShrink: 0, transition: 'transform 0.2s ease', transform: isOpen ? 'rotate(180deg)' : 'none' }} />
            </button>
            {isOpen && (
              // Plain black, not the theme's tinted text (Jade).
              <p style={{ margin: 0, padding: '0 0 12px', fontSize: 12.5, lineHeight: 1.5, color: '#000' }}>
                {f.a}
                {f.link && (
                  <>
                    {' '}
                    <a href={f.link.href} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--c-text-accent)', fontWeight: 700 }}>{f.link.label}</a>
                  </>
                )}
              </p>
            )}
          </li>
        );
      })}
    </ul>
  );
}
